import type { BoundingBox } from '@/interfaces';

export type PopularDestination = {
    label: string;
    value: string;
    boundingBox: BoundingBox;
    country?: string;
};

export const destinations: PopularDestination[] = [
    {
        label: 'Spania',
        value: 'spania',
        boundingBox: { minLat: 33.499548, minLon: -9.716923, maxLat: 46.044901, maxLon: 3.403853 },
        country: 'Spania',
    },
    {
        label: 'Kanariøyene, Spania',
        value: 'kanariaoyene',
        boundingBox: { minLat: 27.425414, minLon: -18.391113, maxLat: 29.463514, maxLon: -13.31543 },
    },
    {
        label: 'Mallorca, Spania',
        value: 'mallorca',
        boundingBox: { minLat: 38.928941, minLon: 2.274538, maxLat: 40.212491, maxLon: 3.606711 },
    },
    {
        label: 'Costa del Sol, Spania',
        value: 'costa-del-sol',
        boundingBox: { minLat: 35.946883, minLon: -5.435486, maxLat: 36.831272, maxLon: -4.55658 },
    },
    {
        label: 'Costa Blanca, Spania',
        value: 'costa-blanca',
        boundingBox: { minLat: 37.365791, minLon: -1.439209, maxLat: 39.0917, maxLon: 0.318604 },
    },
    {
        label: 'Hellas',
        value: 'hellas',
        boundingBox: { minLat: 33.394675, minLon: 19.829526, maxLat: 41.942383, maxLon: 28.486011 },
        country: 'Hellas',
    },
    {
        label: 'Kreta, Hellas',
        value: 'kreta',
        boundingBox: { minLat: 34.800883, minLon: 23.471621, maxLat: 35.695695, maxLon: 26.352519 },
    },
    {
        label: 'Rhodos, Hellas',
        value: 'rhodos',
        boundingBox: { minLat: 35.825825, minLon: 27.542335, maxLat: 36.540608, maxLon: 28.540816 },
    },
    {
        label: 'Italia',
        value: 'italia',
        boundingBox: { minLat: 35.4897, minLon: 6.62672, maxLat: 47.092, maxLon: 18.7976 },
        country: 'Italia',
    },
    {
        label: 'Kroatia',
        value: 'kroatia',
        boundingBox: { minLat: 42.338509, minLon: 13.3649, maxLat: 46.55502, maxLon: 19.447377 },
        country: 'Kroatia',
    },
    {
        label: 'Kypros',
        value: 'kypros',
        boundingBox: { minLat: 33.177452, minLon: 32.183976, maxLat: 35.920032, maxLon: 34.6818 },
        country: 'Kypros',
    },
    {
        label: 'Tyrkia',
        value: 'tyrkia',
        boundingBox: { minLat: 35.805916, minLon: 25.440814, maxLat: 42.3667, maxLon: 44.817845 },
        country: 'Tyrkia',
    },
    {
        label: 'Portugal',
        value: 'portugal',
        boundingBox: { minLat: 36.531357, minLon: -11.307449, maxLat: 42.43076, maxLon: -5.186391 },
        country: 'Portugal',
    },
    {
        label: 'Thailand',
        value: 'thailand',
        boundingBox: { minLat: 5.613038, minLon: 97.343396, maxLat: 20.465143, maxLon: 105.636812 },
        country: 'Thailand',
    },
    {
        label: 'Frankrike',
        value: 'frankrike',
        boundingBox: { minLat: 40.49799, minLon: -5.042647, maxLat: 51.801551, maxLon: 8.07813 },
        country: 'Frankrike',
    },
    {
        label: 'Polen',
        value: 'polen',
        boundingBox: { minLat: 49.002046, minLon: 14.122864, maxLat: 54.905476, maxLon: 24.145874 },
        country: 'Polen',
    },
    {
        label: 'Albania',
        value: 'albania',
        boundingBox: { minLat: 39.638703, minLon: 18.994868, maxLat: 42.661081, maxLon: 21.057282 },
        country: 'Albania',
    },
    {
        label: 'Egypt',
        value: 'egypt',
        boundingBox: { minLat: 22.0, minLon: 24.696775, maxLat: 31.8122, maxLon: 37.0569 },
        country: 'Egypt',
    },
];
